import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Typography, Stack, useTheme } from "@mui/material";

const VAT_REPORT_DISCLAIMER =
  "VAT reports are generated based on available data. It is the user's responsibility to ensure all data is correctly captured for a holistic overview. Please be advised that data may require adjustment based on specific internal rules. A final validation of all figures must be performed prior to filing with Tax Authority.";

const VATReportDisclaimerBanner = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        backgroundColor: "rgba(255, 249, 237, 1)",
        border: "1px solid rgba(235, 218, 173, 1)",
        borderRadius: "8px",
        px: 1.5,
        py: 1.25,
        mb: 2,
      }}
    >
      <Stack spacing={1} direction="row" alignItems="flex-start">
        <InfoOutlinedIcon sx={{ color: "rgb(124,98,78)" }} />
        <Typography
          variant="body2"
          sx={{ color: "rgb(124,98,78)", fontWeight: 400 }}
        >
          {VAT_REPORT_DISCLAIMER}
        </Typography>
      </Stack>
    </Box>
  );
};

export default VATReportDisclaimerBanner;
